module.exports = __webpack_public_path__ + "media/images/logo_red_transparent-2b101b1e5f20c295bfa845c48a580752.png";